import tgAxios from "@/api/api-axios";
import { ApiResponse } from "@/types/app.type";
import {
  NotificationListParams,
  NotificationStatistics,
  NotificationType,
  NotificationUnreadCount,
} from "../types/notification.type";

export const getNotificationList = (params?: NotificationListParams) => {
  return tgAxios.get("/notifications", { params });
};
export const getNotificationStatistics = (): Promise<
  ApiResponse<NotificationStatistics>
> => {
  return tgAxios.get("/notifications/statistics");
};

export const getNotificationUnreadCount = (params?: {
  type?: NotificationType;
}): Promise<ApiResponse<NotificationUnreadCount>> => {
  return tgAxios.get("/notifications/unread-count", { params });
};
export const readNotification = (notificationUserId: string) => {
  return tgAxios.put(`/notifications/mark`, {
    notificationUserId,
    isRead: true,
  });
};
export const readAllNotification = () => {
  return tgAxios.put(`/notifications/mark-all-read`);
};